import { createSelector } from 'react-sweet-state';

import type { FieldId } from '../../../../common/types/form/form-fields';
import type { FormRendererState } from '../../types';

export interface FieldCustomErrorSelectorProps {
	fieldId: FieldId;
}

export const fieldCustomErrorSelector: import('react-sweet-state').OutputSelector<
	FormRendererState,
	FieldCustomErrorSelectorProps,
	string | undefined
> = createSelector(
	(state: FormRendererState) => state.fieldCustomErrors,
	(_, props: FieldCustomErrorSelectorProps) => props.fieldId,
	(fieldCustomErrors, fieldId): string | undefined => fieldCustomErrors[fieldId],
);
